import { render, staticRenderFns } from "./DataPrimaryUser.vue?vue&type=template&id=509556c4&scoped=true"
import script from "./DataPrimaryUser.vue?vue&type=script&lang=js"
export * from "./DataPrimaryUser.vue?vue&type=script&lang=js"
import style0 from "./DataPrimaryUser.vue?vue&type=style&index=0&id=509556c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509556c4",
  null
  
)

export default component.exports